<template>
  <div id="app">
    <div class="web_container">
      <div class="body_container">
        <!-- 头部 -->
        <div class="header_container">
          <img class="header_ico" src="../assets/application_intro/ico_logo.png" />
          <div class="header_content_container">
            <img class="header_content_wechat" src="../assets/application_intro/ico_wechat.png" />
            <div class="header_content_text_container">
              <span class="header_content_title">清兮</span>
              <span class="header_content_dec">静坐放松，在压力中寻觅清凉自在，发现本源的快乐和圆满……</span>
            </div>
            <img class="header_content_cat" src="../assets/big_picture/ico_cat.png" />
          </div>
        </div>
        <!-- 内容 -->
        <div class="content_container">
          <img class="picture_container" src="../assets/application_intro/content.png" />
          <!-- 分割线 -->
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div class="phone_container">
        <div class="phone_body_container">
          <!-- 头部 -->
          <div class="phone_header_container">
            <img class="phone_header_ico" src="../assets/application_intro/ico_logo.png" />
            <span class="phone_header_content_title">清兮</span>
            <span class="phone_header_content_dec">静坐放松，在压力中寻觅清凉自在，发现本源的快乐和圆满……</span>
          </div>
          <!-- 内容 -->
          <div class="phone_content_container">
            <img class="phone_content_wechat" src="../assets/application_intro/ico_wechat.png" />
            <img class="phone_picture_content_container" src="../assets/application_intro/content.png" />
            <!-- 分割线 -->
            <div class="phone_line"></div>
          </div>
        </div>
      </div>

  </div>
</template>

<script>
  export default {
      name: 'bigPicture',
      data() {
        return {
          items: [{
              title: '轮回',
              dec: '人生，梦如路长',
              article: 'https://mp.weixin.qq.com/s/W4acqVvRR5jQ20uNQIZOHA',
              img: require('../assets/big_picture/item1.png'),
              index: 0
            },
            {
              title: '与佛系女友在一起的108天',
              dec: '陪你度过漫长岁月',
              article: 'https://mp.weixin.qq.com/s/xrSQF-L4aXiLZxmvuk0uVA',
              img: require('../assets/big_picture/item2.png'),
              index: 0
            },
            {
              title: '我是谁',
              dec: '一个适合闭上眼问自己的问题',
              article: 'https://mp.weixin.qq.com/s/TQ-Fzn7Q6wogfOymf89XLQ',
              img: require('../assets/big_picture/item3.png'),
              index: 0
            },
            {
              title: '般若•心经',
              dec: '至尊宝穿越时空念的是什么',
              article: 'https://mp.weixin.qq.com/s/Ff-dOWVE05UnXo3wfdhzYA',
              img: require('../assets/big_picture/item4.png'),
              index: 0
            },
            {
              title: '无常',
              dec: '画里乾坤，这还是你心中那个世界吗？',
              article: 'https://mp.weixin.qq.com/s/afKOWCvcaDx-9KsuEUuk8A',
              img: require('../assets/big_picture/item5.png'),
              index: 0
            },
            {
              title: '入定',
              dec: '嘘！轻一点我正在入定',
              article: 'https://mp.weixin.qq.com/s/msxyOpRf0fhWWJRhl5jozQ',
              img: require('../assets/big_picture/item6.png'),
              index: 0
            },
          ],
        };
      },
      methods: {
        onArticleItemClick(item, index) {
          var url = item.article;
          window.open(url, '_blank')
          //window.location.href = item.article;
        }
      }
    }

</script>

<style scoped>
  @font-face {
    font-family: ht;
    src: url("../assets/font/HT.otf");
  }

  .web_container {
    width: 100%;
  }

  .body_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header_container {
    background-size: 100%;
    width: 100%;
    height: 25vw;
    background-image: url('../assets/home/bg_header.png');
    /* background-repeat: no-repeat; */
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: center;
  }

  .header_ico {
    height: 10.520833vw;
    width: 10.520833vw;
    margin-bottom: 0.989583vw;
  }

  .header_content_container {
    width: 37.5vw;
    height: 12.5vw;
    background: rgba(237, 237, 238, 0.7);
    border-radius: 1.25vw;
    border: 0.15625vw solid #FFFFFF;
    margin-left: 1.822916vw;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .header_content_wechat {
    height: 10.416666vw;
    width: 10.416666vw;
    margin-left: 1.041666vw;
  }

  .header_content_text_container {
    display: flex;
    flex-direction: column;
  }

  .header_content_title {
    font-family: ht;
    font-size: 2.5vw;
    color: #000000;
    margin-left: 1.666666vw;
  }

  .header_content_dec {
    font-family: ht;
    font-size: 1.25vw;
    color: #4E4D4D;
    margin-top: 1.25vw;
    margin-left: 1.666666vw;
  }

  .header_content_cat {
    height: 6.25vw;
    width: 6.614583vw;
    margin-top: 6.25vw;
  }

  .content_container {
    background-size: 100%;
    width: 100%;
    background-image: url('../assets/home/bg_content.png');
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .picture_container {
    width: 53.333333vw;
    justify-content: center;
    margin-top: 4.375vw;
    flex-wrap: wrap;
  }

  .picture_content_container {
    display: flex;
    flex-direction: column;
    margin-top: 3.75vw;
    margin-left: 1.25vw;
  }

  .picture_img {
    width: 18.75vw;
    height: 11.145833vw;
    border: 0.15625vw solid #FFFFFF;
  }

  .picture_title {
    font-family: 'PingFang SC';
    font-size: 1.25vw;
    color: #000000;
    margin-top: 1.25vw;
  }

  .picture_dec {
    font-family: 'PingFang SC';
    font-size: 1.041666vw;
    color: #9B9B9B;
    margin-top: 0.416666vw;
  }

  .bottom_dec {
    font-family: ht;
    font-size: 1.25vw;
    color: #4E4D4D;
    margin-top: 8.333333vw;
  }

  .bottom_img {
    width: 16.875vw;
    height: 10.9375vw;
    margin-top: 1.666666vw;
  }

  .line {
    height: 0.052083vw;
    width: 52.083333vw;
    background-color: rgba(151, 151, 151, 0.3);
    margin-top: 4.166666vw;
    margin-bottom: 4.166666vw;
  }
  .phone_container {
    width: 100%;
  }

  .phone_body_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_header_container {
    background-size: 100%;
    width: 100%;
    height: 87.466666vw;
    background-image: url('../assets/home/phone_bg_header.png');
    /* background-repeat: no-repeat; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_header_ico {
    height: 21.866666vw;
    width: 21.866666vw;
    margin-top:21.333333vw;
  }

  .phone_header_content_title {
    font-family: ht;
    font-size: 6.4vw;
    color: #000000;
    margin-top: 6.4vw;
  }

  .phone_header_content_dec {
    font-family: ht;
    font-size: 4.266666vw;
    color: #4E4D4D;
    margin-top: 2.133333vw;
  }

  .phone_content_wechat {
    height: 25.466666vw;
    width: 25.466666vw;
    margin-bottom:4.266666vw;
  }
  .phone_content_container {
    background-size: 100%;
    width: 100%;
    background-image: url('../assets/home/bg_content.png');
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_picture_content_container {
    display: flex;
    flex-direction: column;
    width: 88.666666vw;
    margin-top:12.8vw;
  }

  .phone_picture_img {
    width: 78.666666vw;
    height: 46.666666vw;
    border: 0.8vw solid #FFFFFF;
  }

  .phone_picture_title {
    font-family: 'PingFang SC';
    font-size: 5.333333vw;
    color: #000000;
    margin-top:2.133333vw;
  }

  .phone_picture_dec {
    font-family: 'PingFang SC';
    font-size: 4.266666vw;
    color: #9B9B9B;
    margin-top: 1.066666vw;
  }

  .phone_line {
    height: 0.266666vw;
    width: 89.333333vw;
    background-color: rgba(151, 151, 151, 0.3);
    margin-top: 17.066666vw;
    margin-bottom: 8.266666vw;
  }
  .phone_bottom_dec {
    font-family: ht;
    font-size: 4.266666vw;
    color: #4E4D4D;
    margin-top: 21.333333vw;
  }

  .phone_bottom_img {
    width: 78.666666vw;
    height: 51.2vw;
    margin-top: 8.533333vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/ApplicationIntro.vue